import React, { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown } from 'lucide-react';

export default function RoleDropdown({ id, roles, value, loading, disabled = false, error, onChange, onBlur }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const selected = roles.find(role => String(role.id) === String(value));
  useEffect(() => {
    if (!open) return undefined;
    function outside(event) { if (!root.current?.contains(event.target)) setOpen(false); }
    root.current?.querySelector('[aria-selected="true"]')?.focus();
    document.addEventListener('mousedown', outside);
    return () => document.removeEventListener('mousedown', outside);
  }, [open]);
  function close() { setOpen(false); trigger.current?.focus(); }
  function key(event) {
    if (event.key === 'Escape' && open) { event.preventDefault(); event.stopPropagation(); close(); return; }
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      if (!open) { setOpen(true); return; }
      const options = Array.from(root.current.querySelectorAll('[role="option"]'));
      const current = options.indexOf(document.activeElement);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1
        : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options[index]?.focus();
    }
  }
  return <div className={`wh-form-select${error ? ' invalid' : ''}`} ref={root} onKeyDown={key}
    onBlur={event => { if (!root.current?.contains(event.relatedTarget)) { setOpen(false); onBlur(); } }}>
    <button id={id} ref={trigger} className={`wh-form-select-trigger${open ? ' open' : ''}${selected ? '' : ' placeholder'}`} type="button" role="combobox"
      aria-labelledby={`${id}-label`} aria-haspopup="listbox" aria-expanded={open} aria-controls={open ? `${id}-options` : undefined}
      aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} disabled={disabled || loading || !roles.length}
      onClick={() => setOpen(current => !current)}>
      <span className="wh-form-select-value">{loading ? 'Loading roles...' : selected?.name || 'Select role'}</span>
      {!disabled && <ChevronDown size={16} strokeWidth={1.8} className="wh-form-select-caret" />}
    </button>
    {open && <div className="wh-form-select-menu"><div className="wh-menu-list" role="listbox" id={`${id}-options`} aria-labelledby={`${id}-label`}>
      {roles.map(role => <button key={role.id} className={`wh-menu-item${String(value) === String(role.id) ? ' selected' : ''}`} type="button" role="option"
        aria-selected={String(value) === String(role.id)} onClick={() => { onChange(String(role.id)); close(); }}>
        <span>{role.name}</span>{String(value) === String(role.id) && <Check size={14} strokeWidth={2} />}
      </button>)}
    </div></div>}
  </div>;
}
